/* Rendu avis produit Petzeal PL -- bandeau (reviews_strip) + grille (product-reviews-grid).
   Une seule source de donnees (window.PTZ_REVIEWS, cf assets/ptz-reviews-data.js), zero app
   tierce (ni ViVA/Sarm ni Klaviyo). Si le produit n'a pas encore d'avis generes, le bandeau
   garde son pool generique existant (fallback Liquid deja en place) et la grille se masque
   entierement -- jamais de grille vide affichee. */
(function () {
  "use strict";

  function starsHtml(rating, size) {
    size = size || 14;
    var full = '<svg viewBox="0 0 18 19" width="' + size + '" height="' + size + '" fill="#3A6351" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.4 0.565613C2.41766 0.565613 0 2.98328 0 5.96561V13.1656C0 16.1479 2.41766 18.5656 5.4 18.5656H12.6C15.5823 18.5656 18 16.1479 18 13.1656V5.96561C18 2.98328 15.5823 0.565613 12.6 0.565613H5.4ZM10.3718 7.67804L9.00041 3.73275L7.62903 7.67804L3.45306 7.76314L6.78147 10.2866L5.57196 14.2844L9.00041 11.8987L12.4289 14.2844L11.2194 10.2866L14.5478 7.76314L10.3718 7.67804Z"/></svg>';
    var empty = full.replace('fill="#3A6351"', 'fill="#D8D8D8"');
    var out = "";
    for (var i = 0; i < 5; i++) out += i < rating ? full : empty;
    return out;
  }

  function getReviews(productId) {
    // 08/10/2026 : priorite aux avis saisis dans l'admin (metafield custom.avis_clients), sinon ancienne source.
    var meta = (window.PTZ_REVIEWS_META || {})[String(productId)];
    // gabarit a remplir (rating 0 / "DO UZUPEŁNIENIA") : jamais affiche
    if (Array.isArray(meta)) meta = meta.filter(function (r) {
      return r && Number(r.rating) >= 1 && String(r.author || "").indexOf("DO UZUPE") !== 0 && String(r.reviewBody || "").indexOf("DO UZUPE") !== 0;
    });
    if (meta && meta.length) return meta;
    var data = window.PTZ_REVIEWS || {};
    return data[String(productId)] || null;
  }

  function renderStrip(container, reviews) {
    // Remplace le pool generique Liquid par le vrai contenu du produit, meme structure de carte.
    var track = container.querySelector(".ptz-bs-track");
    if (!track) return;
    var cards = reviews.concat(reviews).map(function (r) {
      return (
        '<div class="ptz-bs-card">' +
          '<div class="ptz-bs-row1">' +
            '<span class="ptz-bs-author">' + r.author + "</span>" +
            '<div class="ptz-bs-stars">' + starsHtml(r.rating) + "</div>" +
          "</div>" +
          '<div class="ptz-bs-text">' + r.reviewBody + "</div>" +
        "</div>"
      );
    });
    track.innerHTML = cards.join("");
  }


  // 01/11/2026 : photos facultatives d'un avis ("image" ou "images"), uniquement cdn.shopify.com, vignettes carrées + agrandissement au clic
  function photosAvis(r) {
    var l = [].concat(r.images || [], r.image ? [r.image] : []).filter(function (u) {
      return typeof u === "string" && /^https:\/\/cdn\.shopify\.com\/[^"'<>\s]+$/.test(u);
    }).slice(0, 4);
    if (!l.length) return "";
    return '<div class="ptz-grid-photos">' + l.map(function (u) {
      var t = u + (u.indexOf("?") < 0 ? "?" : "&") + "width=160";
      return '<button type="button" class="ptz-grid-photo" data-ptz-photo="' + u + '" aria-label="Zdjęcie od klienta">' +
             '<img src="' + t + '" alt="Zdjęcie od klienta" loading="lazy" width="72" height="72"></button>';
    }).join("") + "</div>";
  }
  function stylePhotos() {
    if (document.getElementById("ptz-photos-css")) return;
    var s = document.createElement("style"); s.id = "ptz-photos-css";
    s.textContent = ".ptz-grid-photos{display:flex;gap:6px;flex-wrap:wrap;margin-top:8px}" +
      ".ptz-grid-photo{padding:0;border:0;background:none;cursor:zoom-in;width:72px;height:72px;border-radius:6px;overflow:hidden}" +
      ".ptz-grid-photo img{width:72px;height:72px;object-fit:cover;display:block}" +
      ".ptz-photo-zoom{position:fixed;inset:0;background:rgba(0,0,0,.85);display:flex;align-items:center;justify-content:center;z-index:2147483000;cursor:zoom-out}" +
      ".ptz-photo-zoom img{max-width:92vw;max-height:88vh;border-radius:8px}";
    document.head.appendChild(s);
    document.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest("[data-ptz-photo]");
      if (b) { var z = document.createElement("div"); z.className = "ptz-photo-zoom";
        z.innerHTML = '<img src="' + b.getAttribute("data-ptz-photo") + '?width=1200" alt="Zdjęcie od klienta">';
        z.addEventListener("click", function () { z.remove(); }); document.body.appendChild(z); return; }
    });
  }
  function renderGrid(container, reviews) {
    var grid = container.querySelector("[data-ptz-grid]");
    if (!grid) return;
    var avg = (reviews.reduce(function (s, r) { return s + r.rating; }, 0) / reviews.length).toFixed(1);
    var badge = container.querySelector("[data-ptz-grid-badge]");
    if (badge) {
      badge.innerHTML =
        '<span class="ptz-grid-badge-stars">' + starsHtml(Math.round(avg)) + "</span>" +
        '<span class="ptz-grid-badge-text">' + avg + " / 5 &middot; " + reviews.length + " opinii</span>";
    }
    stylePhotos();
    grid.innerHTML = reviews.map(function (r) {
      return (
        '<div class="ptz-grid-card">' +
          '<div class="ptz-grid-card-top">' +
            '<span class="ptz-grid-author">' + r.author + "</span>" +
            '<div class="ptz-grid-stars">' + starsHtml(r.rating) + "</div>" +
          "</div>" +
          '<p class="ptz-grid-text">' + r.reviewBody + "</p>" +
          photosAvis(r) +
        "</div>"
      );
    }).join("");
    container.style.display = "";
  }

  function renderBadge(container, reviews) {
    var avg = (reviews.reduce(function (s, r) { return s + r.rating; }, 0) / reviews.length).toFixed(1);
    var starsC = container.querySelector("[data-ptz-badge-stars]");
    var textC = container.querySelector("[data-ptz-badge-text]");
    if (starsC) starsC.innerHTML = starsHtml(Math.round(avg), 15);
    if (textC) textC.textContent = avg + " (" + reviews.length + ")";
    // colle le badge DANS le vrai conteneur de prix (.price, trouve dans la colonne info du
    // produit -- pas previousElementSibling, qui pointe sur un <form> dans ce theme, ni un
    // simple ".price" global qui matcherait aussi le mini-panier). Garantit l'affichage a
    // cote du prix quel que soit le markup exact du theme.
    var infoContainer = container.closest(".product__info-container") || document;
    var priceEl = infoContainer.querySelector(".price");
    if (priceEl) {
      container.style.display = "inline-flex";
      container.style.verticalAlign = "middle";
      container.style.marginLeft = "6px";
      container.style.gap = "4px";
      priceEl.style.display = "flex";
      priceEl.style.flexWrap = "wrap";
      priceEl.style.alignItems = "center";
      priceEl.style.gap = "8px";
      priceEl.appendChild(container);
    } else {
      container.style.display = "flex";
    }
  }

  function polishPriceDisplay() {
    // retire le badge "W promocji" (demande Mustafa, jugee moche) + reduit la taille de
    // l'ancien prix barre -- independant des avis, doit tourner sur TOUTE fiche en promo,
    // meme celles sans donnees d'avis encore generees
    document.querySelectorAll(".price__badge-sale").forEach(function (el) {
      el.style.display = "none";
    });
    document.querySelectorAll(".price s").forEach(function (el) {
      el.style.fontSize = "0.75em";
      el.style.opacity = "0.7";
    });
  }

  function init() {
    var productId = document.body.getAttribute("data-ptz-product-id");
    if (!productId) return;
    var reviews = getReviews(productId);

    polishPriceDisplay();

    var badge = document.querySelector("[data-ptz-badge]");
    if (badge && reviews && reviews.length > 0) renderBadge(badge, reviews);
    // pas de "else" : si aucune donnee, le badge reste masque (jamais de badge a 0 avis).

    var strip = document.querySelector("[data-ptz-strip]");
    if (strip && reviews) renderStrip(strip, reviews);
    // pas de "else" : si aucune donnee, le bandeau garde son pool generique existant (fallback).

    var gridSection = document.querySelector("[data-ptz-grid-section]");
    if (gridSection) {
      if (reviews && reviews.length > 0) {
        renderGrid(gridSection, reviews);
      } else {
        gridSection.style.display = "none"; // jamais de grille vide affichee
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
